import { Badge, Box, Flex, Group, Stack, Text, Tooltip } from '@mantine/core';

import { resolveSpintax } from '../../../../../utils/text';

const MessageContentCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    const variation = resolveSpintax(rowData.rawMessage);
    return (
        <Tooltip
            maw={300}
            multiline={true}
            label={
                <Text
                    inline
                    span
                    maw={200}
                    size={'sm'}
                    lineClamp={20}>
                    {variation}
                </Text>
            }>
            <Text
                maw={400}
                truncate='end'>
                {variation}
            </Text>
        </Tooltip>
    );
};

const MessageContentColumn = () => ({
    accessorKey: 'messageContent',
    header: 'Message Content',
    size: 1,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <MessageContentCell cell={cell} />,
});
export default MessageContentColumn;
